export var IProductPageResponse;
(function (IProductPageResponse) {
    let IPdpProduct;
    (function (IPdpProduct) {
        let IVisuals;
        (function (IVisuals) {
            /**
             * Return an instance of IVisuals with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IVisuals.build = (partial) => (Object.assign({ badges: [], images: [], videos: [] }, (partial !== null && partial !== void 0 ? partial : {})));
        })(IVisuals = IPdpProduct.IVisuals || (IPdpProduct.IVisuals = {}));
        let IPurchaseInformation;
        (function (IPurchaseInformation) {
            /**
             * Return an instance of IPurchaseInformation with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IPurchaseInformation.build = (partial) => (Object.assign({ tester_prices: [], style_groups: {}, customizations: [] }, (partial !== null && partial !== void 0 ? partial : {})));
        })(IPurchaseInformation = IPdpProduct.IPurchaseInformation || (IPdpProduct.IPurchaseInformation = {}));
        let IDetails;
        (function (IDetails) {
            let IProductInformationSubSection;
            (function (IProductInformationSubSection) {
                let ILink;
                (function (ILink) {
                    /**
                     * Return an instance of ILink with the provided fields. Any field not
                     * listed will be populated with an empty value (an empty array,
                     * or undefined, whichever is valid for the type of the value.)
                     */
                    ILink.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
                })(ILink = IProductInformationSubSection.ILink || (IProductInformationSubSection.ILink = {}));
                let Type;
                (function (Type) {
                    Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
                    Type["DESCRIPTION"] = "DESCRIPTION";
                    Type["DETAILS"] = "DETAILS";
                    Type["SAFETY_INFORMATION"] = "SAFETY_INFORMATION";
                    Type["ECO_FRIENDLY"] = "ECO_FRIENDLY";
                })(Type = IProductInformationSubSection.Type || (IProductInformationSubSection.Type = {}));
                let IUserTranslatedAttribute;
                (function (IUserTranslatedAttribute) {
                    /**
                     * Return an instance of IUserTranslatedAttribute with the provided fields. Any field not
                     * listed will be populated with an empty value (an empty array,
                     * or undefined, whichever is valid for the type of the value.)
                     */
                    IUserTranslatedAttribute.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
                })(IUserTranslatedAttribute = IProductInformationSubSection.IUserTranslatedAttribute || (IProductInformationSubSection.IUserTranslatedAttribute = {}));
                let IProductInformationSubSectionEntry;
                (function (IProductInformationSubSectionEntry) {
                    /**
                     * Return an instance of IProductInformationSubSectionEntry with the provided fields. Any field not
                     * listed will be populated with an empty value (an empty array,
                     * or undefined, whichever is valid for the type of the value.)
                     */
                    IProductInformationSubSectionEntry.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
                })(IProductInformationSubSectionEntry = IProductInformationSubSection.IProductInformationSubSectionEntry || (IProductInformationSubSection.IProductInformationSubSectionEntry = {}));
                let IOptionLevelEntries;
                (function (IOptionLevelEntries) {
                    /**
                     * Return an instance of IOptionLevelEntries with the provided fields. Any field not
                     * listed will be populated with an empty value (an empty array,
                     * or undefined, whichever is valid for the type of the value.)
                     */
                    IOptionLevelEntries.build = (partial) => (Object.assign({ entries: [] }, (partial !== null && partial !== void 0 ? partial : {})));
                })(IOptionLevelEntries = IProductInformationSubSection.IOptionLevelEntries || (IProductInformationSubSection.IOptionLevelEntries = {}));
                let IModalInformationSection;
                (function (IModalInformationSection) {
                    let IAttributeValueDetail;
                    (function (IAttributeValueDetail) {
                        /**
                         * Return an instance of IAttributeValueDetail with the provided fields. Any field not
                         * listed will be populated with an empty value (an empty array,
                         * or undefined, whichever is valid for the type of the value.)
                         */
                        IAttributeValueDetail.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
                    })(IAttributeValueDetail = IModalInformationSection.IAttributeValueDetail || (IModalInformationSection.IAttributeValueDetail = {}));
                    /**
                     * Return an instance of IModalInformationSection with the provided fields. Any field not
                     * listed will be populated with an empty value (an empty array,
                     * or undefined, whichever is valid for the type of the value.)
                     */
                    IModalInformationSection.build = (partial) => (Object.assign({ value_details: [] }, (partial !== null && partial !== void 0 ? partial : {})));
                })(IModalInformationSection = IProductInformationSubSection.IModalInformationSection || (IProductInformationSubSection.IModalInformationSection = {}));
                /**
                 * Return an instance of IProductInformationSubSection with the provided fields. Any field not
                 * listed will be populated with an empty value (an empty array,
                 * or undefined, whichever is valid for the type of the value.)
                 */
                IProductInformationSubSection.build = (partial) => (Object.assign({ entries: [], option_level_entries_by_option_token: {}, modal_information_sections: [] }, (partial !== null && partial !== void 0 ? partial : {})));
            })(IProductInformationSubSection = IDetails.IProductInformationSubSection || (IDetails.IProductInformationSubSection = {}));
            let IProductInformationSectionGroup;
            (function (IProductInformationSectionGroup) {
                /**
                 * Return an instance of IProductInformationSectionGroup with the provided fields. Any field not
                 * listed will be populated with an empty value (an empty array,
                 * or undefined, whichever is valid for the type of the value.)
                 */
                IProductInformationSectionGroup.build = (partial) => (Object.assign({ sections: [] }, (partial !== null && partial !== void 0 ? partial : {})));
            })(IProductInformationSectionGroup = IDetails.IProductInformationSectionGroup || (IDetails.IProductInformationSectionGroup = {}));
            /**
             * Return an instance of IDetails with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IDetails.build = (partial) => (Object.assign({ attribute_tags: [], product_option_measurements: {}, product_information_section_groups: [] }, (partial !== null && partial !== void 0 ? partial : {})));
        })(IDetails = IPdpProduct.IDetails || (IPdpProduct.IDetails = {}));
        let IMessages;
        (function (IMessages) {
            /**
             * Return an instance of IMessages with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IMessages.build = (partial) => (Object.assign({ info_texts: [], disclaimers: [] }, (partial !== null && partial !== void 0 ? partial : {})));
        })(IMessages = IPdpProduct.IMessages || (IPdpProduct.IMessages = {}));
        let IShippingInformation;
        (function (IShippingInformation) {
            /**
             * Return an instance of IShippingInformation with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IShippingInformation.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
        })(IShippingInformation = IPdpProduct.IShippingInformation || (IPdpProduct.IShippingInformation = {}));
        /**
         * Return an instance of IPdpProduct with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IPdpProduct.build = (partial) => (Object.assign({ options: {}, board_tokens: [], promoted_by: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IPdpProduct = IProductPageResponse.IPdpProduct || (IProductPageResponse.IPdpProduct = {}));
    let IPdpBrand;
    (function (IPdpBrand) {
        /**
         * Return an instance of IPdpBrand with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IPdpBrand.build = (partial) => (Object.assign({ active_promo_collections: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IPdpBrand = IProductPageResponse.IPdpBrand || (IProductPageResponse.IPdpBrand = {}));
    /**
     * Return an instance of IProductPageResponse with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProductPageResponse.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IProductPageResponse || (IProductPageResponse = {}));
